// --- Our Modules --------------------------------------------------------------------------------
import Icon from "@/UI/atoms/Icon";
import type { TyIconName } from "@/UI/atoms/Icon/types";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = {
    /** What is missing, drawn. The section's own icon, so an empty tab still says which tab it is. */
    icon?: TyIconName;
    title: string;
    /** Why it is empty, or what fills it. Left out where the title already says both. */
    description?: string;
    /** The one thing to do about it. A list a member may not add to passes nothing. */
    actionLabel?: string;
    onAction?: () => void;
    /** Inside a grid, the message has to cross every column or it sits in the first one. */
    span?: boolean;
};

/**
 * Every empty list, tab and grid in the app.
 *
 * A new organization opens **every** section with nothing in it, so this is the first thing most
 * people ever see of most screens — and a bare grey sentence reads as a screen that failed to load.
 * It is a panel instead: an icon that names the section, a line that says what is missing, and where
 * there is one thing to do about it, the button to do it.
 */
export default function EmptyState({ icon = "search", title, description, actionLabel, onAction, span }: Props) {
    return (
        <section className={`empty-state${span ? " empty-state--span" : ""}`}>
            <span className="empty-state__icon">
                <Icon name={icon} size={26} />
            </span>

            <h3 className="empty-state__title">{title}</h3>
            {description && <p className="empty-state__text">{description}</p>}

            {actionLabel && onAction && (
                <button type="button" className="empty-state__action" onClick={onAction}>
                    <Icon name="add" size={14} />
                    <span>{actionLabel}</span>
                </button>
            )}
        </section>
    );
}
